<template>
  <div class="regist-success" :style="{ height: contentHeight + 'px' }">
    <van-row
      class="regist-success-icon"
      type="flex"
      justify="center"
      align="center"
    >
      <van-col>
        <van-icon name="certificate" />
        <div class="text">注册成功</div>
      </van-col>
    </van-row>

    <van-row
      class="regist-success-tip"
      type="flex"
      justify="center"
      align="center"
    >
      <van-col class="pd">
        <span
          >您已经申请{{
            options.CompanyName
          }}团队参观账户，信息审核将在1-3个工作日内完成，审核通过会收到回复，即可登录团体自助预约。</span
        >
      </van-col>
    </van-row>

    <div class="regist-success-button">
      <van-button type="primary" size="large" @click="onClick">关闭</van-button>
    </div>
  </div>
</template>

<script>
import settingService from "@/services/settingService.js";

export default {
  data() {
    return {
      options: {},
    };
  },
  computed: {
    contentHeight() {
      return document.documentElement.clientHeight - 46;
    },
  },
  methods: {
    onClick() {
      this.$router.push("/my");
    },
  },
  async created() {
    this.options = await settingService.getOptionsAsync();
  },
};
</script>

<style lang="scss">
.regist-success {
  background-color: white;

  &-icon {
    height: 150px;
    text-align: center;
    color: #810102;
    font-size: 50px;
    padding-top: 20px;

    .text {
      font-size: 30px;
      font-weight: bold;
    }
  }

  &-tip {
    height: 100px;
    font-size: 14px;
  }

  &-button {
    margin-top: 50px;
    padding: 0 20px;
  }
}
</style>